export enum OfferAlertVariant {
  CancellationPenalty = 'CancellationPenalty',
  Meal = 'Meal',
  PriceIncrease = 'PriceIncrease',
  PriceDrop = 'PriceDrop'
}
